// 给封面使用的方法 减少封面加载js的大小
export const getkey = (key) => {
  let queryPram = window.location.href.split("?")[1];
  let pram = new URLSearchParams("?" + queryPram);
  let value = pram.get(key);
  if (!value) return null;
  // 空格转为+
  return value.replaceAll(/[\s]/g, '+');
};
export function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}
export function getQueryVariable(variable, realUrl) {

  try {
    // let url = window.location.href.replace(/#.*$/igm, "");
    let url = realUrl || window.location.href.split("?")[1];
    const params = url.split("&")
    for (let i = 0; i < params.length; i++) {
      const [key, value] = params[i].split("=")
      if (key === variable) {
        return value;
      }
    }

    return null;
  } catch (err) {
    return null;
  }
  // var query = window.location.search.substring(1);
  // var vars = query.split("&");
  // for (var i = 0; i < vars.length; i++) {
  //   var pair = vars[i].split("=");
  //   if (pair[0] == variable) {
  //     return pair[1];
  //   }
  // }
  // return false;
}

export function isIPad() {
  let u = navigator.userAgent
  // iPadOS 13+ 将 User-Agent 伪装成 Mac，因此需要结合触摸点判断
  // 1. 传统 iPad UA 包含 'iPad'
  // 2. 新款 iPad (Air/Pro) 在桌面模式下 UA 包含 'Macintosh' 且支持触摸
  return u.indexOf('iPad') > -1 || 
    (u.indexOf('Macintosh') > -1 && navigator.maxTouchPoints && navigator.maxTouchPoints > 0)
}

export function identifyDevicePlatform() {
  let os = function () {
    let u = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(u),
      isSymbian = /(?:SymbianOS)/.test(u) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(u),
      isFireFox = /(?:Firefox)/.test(u),
      // 使用专门的 isIPad 函数判断，它已经处理了 Macintosh + Touch 的情况
      isIPadDevice = isIPad(),
      // 平板判断：明确是 iPad，或者是 Android 平板，或者是 Firefox 平板
      // 注意：不再单纯通过 Macintosh 判断平板，以免误伤 Mac 电脑
      isTablet = isIPadDevice || (isAndroid && !/(?:Mobile)/.test(u)) || (isFireFox && /(?:Tablet)/.test(u)),
      isPhone = /(?:Phone)/.test(u) && !isTablet,
      // PC 判断：不是手机，不是安卓，不是塞班。
      // 如果它是 Mac (非 iPad)，它会在这里被判定为 PC，这是符合预期的
      isPc = !isPhone && !isAndroid && !isSymbian;
    return {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
  }();

  if (os.isAndroid || os.isPhone) {
    localStorage.setItem('devicePlatform', 'phone')
    return 'phone'
  } else if (os.isTablet) {
    localStorage.setItem('devicePlatform', 'pad')
    return 'pad'
  } else if (os.isPc) {
    localStorage.setItem('devicePlatform', 'pc')
    return 'pc'
  }
}

export function isWeChat() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

export function getOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"  
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710  
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

export function isVideo(url) {
  if (!url) return false;
  if (typeof url !== 'string') { return false }
  const videoSuffix = ['mp4', 'avi', 'mpg', 'wmv', 'mov', 'm4v', 'mpeg'];

  // 移除URL中的查询参数和哈希部分
  const cleanUrl = url.split(/[#?]/);
  const arr = cleanUrl[0].split(".")
  const suffix = arr[arr.length - 1]
  return videoSuffix.indexOf(suffix?.toLocaleLowerCase()) >= 0

}

export function replaceUrlPort(url) {
  if (url.indexOf('https://app-test.obs.cn-east-2.myhuaweicloud.com') >= 0) {
    return url?.replace(
      "https://app-test.obs.cn-east-2.myhuaweicloud.com:443/",
      "https://oss-panzi-app-test.panzitech.com/"
    );
  }
  return url?.replace(
    "https://oss-panzi-app-test.panzitech.com:443/",
    "https://oss-panzi-app-test.panzitech.com/"
  );
}

// 快速加载图片
export function useCdn(url) {
  return useCdnNew(url);
  // if (url?.indexOf(':443') > 0) {
  //   return url?.replace(
  //     "https://oss-panzi-app-test.panzitech.com/",
  //     "https://app-test.zjhzoyad.com/"
  //   );
  // }
  // return url?.replace(
  //   "https://oss-panzi-app-test.panzitech.com/",
  //   "https://app-test.zjhzoyad.com/"
  // );
}
// 快速加载图片 暂时用原图地址
export function useCdnNew(url) {
  if (!url) return url;
  if (url?.indexOf(':443') > 0) {
    return replaceUrlPort(url);
  }
  return url;
}

// 判断是否有缩略图
export function isHadByTime(url, startTime) {
  if (!url) return false;
  let lineArr = url.split('/');
  let fileKey = lineArr?.[lineArr.length - 1];
  let dotArr = fileKey?.split('.')
  let nameText = dotArr?.[0]
  if (!nameText) { return false }
  let curTime = nameText.split('_')?.[0];
  return curTime > startTime;
}

export function getZipImg(url,str=`/zip-`) {
  if (!url) { return url }
  if (isVideo(url)) return url;
  const img = useCdn(url);
  if (url.indexOf('zip-') >= 0) return url;
  if (isHadByTime(img, 1640966400000)) {
    var lastIndex = url.lastIndexOf('/');
    if (lastIndex !== -1) {
      return url.substring(0, lastIndex) + str + url.substring(lastIndex + 1);
    }
    // return img.replace(
    //   "https://app-test.zjhzoyad.com/",
    //   "https://app-test.zjhzoyad.com/zip-"
    // );
  }
  return img;
}

// 判断是否有size
export function isHadSize(url) {
  if (!url) return false;
  const str = url.split("_");
  let curTime = str[1];
  if (curTime?.indexOf('byte') >= 0) {
    return parseInt(curTime);
  }
  return null;
}

//图片是否可以压缩 是否超过25mb
export function imgIsEnableYs(url, maxsize = 25) {
  if (!isHadByTime(url, 1699954972150)) return false;
  const size = isHadSize(url);
  if (size) return Math.ceil(size / 1024 / 1024) < maxsize;
  return false;
}

export function toQualityImg(url, isZip = false, thumbnail = false) {
  if (!url) return url;
  if (typeof url !== 'string') return '';
  if (url.indexOf('zip-') >= 0) return url;
  if (isZip) {
    if (url?.toLowerCase()?.endsWith('.gif')) {
      return url
    }
    return getZipImg(url);
  }
  if (isVideo(url)) return url;
  if (!isHadByTime(url, 1640966400000)) return url;
  const img = useCdn(url)
  if (imgIsEnableYs(url)) {
    if (!img || (img?.indexOf('?x-oss-process=image') !== -1)) return img
    return img + (!thumbnail ? `?x-oss-process=image/resize,w_2000,h_2000/quality,q_80` : `?x-oss-process=image/resize,w_300,h_300/quality,q_30`)
  }
  return img
}